import React from 'react';
import WorklistCheckmarkWrapper from './WorklistCheckmark.style';

const WorklistCalendar = ({ onClick, className = 'icon-worklist-calendar', fill = '#627fff;' }) => (
  <WorklistCheckmarkWrapper>
    <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} className={className}>
      <path d="M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10z" fill="#ffffff" />
      <path
        d="M11 1.5a9.5 9.5 0 100 19 9.5 9.5 0 000-19zM.5 11C.5 5.201 5.201.5 11 .5S21.5 5.201 21.5 11 16.799 21.5 11 21.5.5 16.799.5 11z"
        fill={fill}
      />
      <path
        className="alarm"
        d="M14.928 10.06c0-3.05-1.64-4.088-3.175-4.32 0-.015.003-.03.003-.05 0-.384-.34-.69-.756-.69s-.744.306-.744.69c0 .02 0 .035.003.05-1.537.235-3.187 1.276-3.187 4.326 0 3.556-.885 3.937-2.072 4.937h12c-1.181-1.003-2.072-1.387-2.072-4.944zM11.006 17c.838 0 1.525-.622 1.616-1.344H9.39c.087.722.778 1.344 1.615 1.344z"
        fill={fill}
      />
    </svg>
  </WorklistCheckmarkWrapper>
);

export default React.memo(WorklistCalendar);
